import { Card, CardContent, CardHeader } from '@mui/material';
import { PeriodicUsageAlert } from 'components/Devices/PeriodicUsageAlert/PeriodicUsageAlert';
import {
    FormInputGroup,
    FormText,
    FormSelect,
    FormMultiSelect,
} from 'components/form';
import {
    fuelTypeOptions,
    gaugeTypeOptions,
    orientationOptions,
    consumptionTypeOptions,
} from 'components/modals/CreateDeviceModal/sharedSections/Details/Details';
import { includesPeriodicUsage } from 'helpers/device';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../../DeviceConfig.module.scss';

export interface DeviceConfigTankProps {
    /** Whether or not this for a virtual device. */
    isVirtual?: boolean;
}

export const DeviceConfigTank = ({
    isVirtual = false,
}: DeviceConfigTankProps) => {
    const [isPeriodicUsage, setIsPeriodicUsage] = useState(false);
    const { watch } = useFormContext();

    const fuelType = watch('fuelType');
    const consumptionTypes = watch('consumptionType');

    // Determine whether or not to show periodic usage alert.
    useEffect(() => {
        setIsPeriodicUsage(includesPeriodicUsage(fuelType, consumptionTypes));
    }, [consumptionTypes, fuelType]);

    return (
        <div data-testid="DeviceConfigTank" className={styles.section}>
            <Card className={styles.card}>
                <CardHeader title="Tank" />
                <CardContent>
                    <FormInputGroup>
                        <FormText
                            field="capacity"
                            label="Total Tank/Water Capacity (Gal.)"
                            isNumber={true}
                        />
                        <FormSelect
                            field="orientation"
                            options={orientationOptions}
                        />
                    </FormInputGroup>

                    <FormInputGroup>
                        <FormSelect
                            field="fuelType"
                            options={fuelTypeOptions}
                        />
                        {fuelType === 'oil' && (
                            <FormSelect
                                field="gaugeType"
                                options={gaugeTypeOptions}
                            />
                        )}
                    </FormInputGroup>

                    <FormInputGroup>
                        <FormMultiSelect
                            field="consumptionType"
                            options={consumptionTypeOptions}
                        />
                    </FormInputGroup>
                    {isVirtual && isPeriodicUsage && <PeriodicUsageAlert />}
                    <FormInputGroup>
                        <FormText field="delivery_instructions" isTextArea />
                    </FormInputGroup>
                </CardContent>
            </Card>
        </div>
    );
};
